import GenericButton from 'components/token-town/generic-button/GenericButton';
import PageSection from 'components/token-town/page-section/PageSection';
import PurchaseTokensMessage from 'components/token-town/purchase-tokens-message/PurchaseTokensMessage';
import QuantitySelector from 'components/token-town/select-entries/QuantitySelector';
import Link from 'next/link';
import { useState } from 'react';
import { singularOrPlural } from 'utils/common';
import sectionStyles from '../../shared/Section.module.css';
import titleStyles from '../../shared/Title.module.css';
import styles from './PlantTreeSection.module.css';

interface IPlantTree {
  title: string;
  playerTokenCount: number;
  treeCost: number;
  setShowPurchaseTokens: () => void;
  handleRedemption: (quantity: number) => Promise<void>;
}

const PlantTreeSection = ({
  title,
  playerTokenCount,
  treeCost,
  setShowPurchaseTokens,
  handleRedemption,
}: IPlantTree) => {
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [numberOfTrees, setNumberOfTrees] = useState(1);

  const costOfTrees = numberOfTrees * treeCost;
  const hasEnoughTokens = playerTokenCount >= costOfTrees;
  const ctaText = `REDEEM NOW FOR ${singularOrPlural(
    costOfTrees,
    '1 TOKEN',
    `${costOfTrees} TOKENS`
  )}`;
  return (
    <PageSection>
      <div
        className={`${sectionStyles.sectionContainer} ${sectionStyles['sectionContainer--spacious']}`}
      >
        <p className={titleStyles.mainTitle}>{title}</p>
        <p className={`${titleStyles.infoDescription} ${styles.leftAlign}`}>
          You can exchange your tokens to <strong>plant trees</strong> with our
          partner, {''}
          <Link href="https://www.veritree.com">
            <a className={styles.underlineLink} target="_blank">
              veritree
            </a>
          </Link>
          .
        </p>
        <p className={`${titleStyles.infoDescription} ${styles.leftAlign}`}>
          For every tree you plant you'll also get{' '}
          <strong>75 Leaderboard points</strong> (equivalent to 3 entries into
          our monthly {''}
          <Link href="/leaderboard">
            <a className={styles.underlineLink}>Leaderboard Raffle</a>
          </Link>
          ).
        </p>

        <div className={sectionStyles.actionButtons}>
          <QuantitySelector
            type="tree"
            min={1}
            max={4}
            quantity={numberOfTrees}
            setQuantity={setNumberOfTrees}
          />
          <GenericButton
            onClick={async () => {
              setConfirmLoading(true);
              await handleRedemption(numberOfTrees);
              setConfirmLoading(false);
            }}
            // ENG-394 - caused a compile error, probably never needed - disabledMessage={INSUFFICIENT_TOKENS_MESSAGE}
            disabled={!hasEnoughTokens}
            loading={confirmLoading}
          >
            {ctaText}
          </GenericButton>
        </div>

        {!hasEnoughTokens ? (
          <PurchaseTokensMessage
            showTokenPurchaseFlow={setShowPurchaseTokens}
          />
        ) : null}
      </div>
    </PageSection>
  );
};

export default PlantTreeSection;
